import { graphql } from "@/graphql/generated";

export const clearMunicipalPropertyInventorySelectionMutationDocument = graphql(/* GraphQL */ `
  mutation ClearMunicipalPropertyInventorySelection($input: ClearMunicipalPropertyInventorySelectionInput!) {
    clearMunicipalPropertyInventorySelection(input: $input)
  }
`);
